import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'

import LoginComponent from '../../components/LoginComponent.js'
import {ROOT_ROUTE} from '../../constants/auth'
import {loginIfNeeded} from '../../actions'
import GoogleAnalytics from '../../classes/GoogleAnalytics'
import { LOGIN } from '../../constants/commons.js'

/** Container around the login page.
 *
 * Glorified page with a button that says login. More so it's a place where we show nothing but pop up the login prompt.
 */
class LoginContainer extends React.Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    isLoggedIn: PropTypes.bool.isRequired,
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount () {
    GoogleAnalytics.trackGA(LOGIN, this.props.location)
  }

  render () {
    if (this.props.isLoggedIn) {
      return (<Redirect to={ROOT_ROUTE} />)
    } else {
      // Go ahead and dispaly lock
      this.props.dispatch(loginIfNeeded())
      return (<LoginComponent login={() => this.props.dispatch(loginIfNeeded())} />)
    }
  }
}

function mapStateToProps (state) {
  const {isLoggedIn, nextPath} = state.user
  return {
    isLoggedIn,
    nextPath
  }
}

export default connect(mapStateToProps)(LoginContainer)
